/* duskling: Ears trail the gathering and extension of the soft body.
 * Eight authored 16x16 poses; palette and gameplay bounds are unchanged. */

export const duskling_0 = [
  '................',
  '................',
  '................',
  '......o..o......',
  '......N..N......',
  '......N..N......',
  '......oooo......',
  '.....oNNNNo.....',
  '....oNeNNeNo....',
  '....oNwwwwNo....',
  '....oNwwwwNo....',
  '.....oooooo.....',
  '.....o....o.....',
  '................',
  '................',
  '................',
];

export const duskling_1 = [
  '................',
  '................',
  '................',
  '.....o....o.....',
  '......N...N.....',
  '......N..N......',
  '......oooo......',
  '.....oNNNNo.....',
  '....oNeNNeNo....',
  '...oNNwwwwNNo...',
  '.....oNwwNo.....',
  '.....oooooo.....',
  '....o......o....',
  '................',
  '................',
  '................',
];

export const duskling_2 = [
  '................',
  '................',
  '................',
  '....o......o....',
  '.....N....N.....',
  '......N..N......',
  '......oooo......',
  '.....oNNNNo.....',
  '....oNeNNeNo....',
  '.....oNwwNo.....',
  '....oNwwwwNo....',
  '....oooooooo....',
  '....o......o....',
  '................',
  '................',
  '................',
];

export const duskling_3 = [
  '................',
  '................',
  '................',
  '.....o....o.....',
  '......N...N.....',
  '......N..N......',
  '......oooo......',
  '.....oNNNNo.....',
  '....oNeNNeNo....',
  '.....oNwwNo.....',
  '...oNNwwwwNNo...',
  '.....oooooo.....',
  '.....o....o.....',
  '................',
  '................',
  '................',
];

export const duskling_4 = [
  '................',
  '................',
  '................',
  '......o..o......',
  '......N..N......',
  '......N..N......',
  '......oooo......',
  '.....oNNNNo.....',
  '....oNeNNeNo....',
  '.....oNwwNo.....',
  '....oNwwwwNo....',
  '....oooooooo....',
  '......o..o......',
  '................',
  '................',
  '................',
];

export const duskling_5 = [
  '................',
  '................',
  '................',
  '.......oo.......',
  '.......N.N......',
  '......N..N......',
  '......oooo......',
  '.....oNNNNo.....',
  '....oNeNNeNo....',
  '...oNNwwwwNNo...',
  '.....oNwwNo.....',
  '.....oooooo.....',
  '......o..o......',
  '................',
  '................',
  '................',
];

export const duskling_6 = [
  '................',
  '................',
  '................',
  '......o..o......',
  '......N..N......',
  '......N..N......',
  '......oooo......',
  '.....oNNNNo.....',
  '....oNeNNeNo....',
  '....oNwwwwNo....',
  '....oNwwwwNo....',
  '.....oooooo.....',
  '.......oo.......',
  '................',
  '................',
  '................',
];

export const duskling_7 = [
  '................',
  '................',
  '................',
  '.....o....o.....',
  '......N...N.....',
  '......N..N......',
  '......oooo......',
  '.....oNNNNo.....',
  '....oNeNNeNo....',
  '.....oNwwNo.....',
  '...oNNwwwwNNo...',
  '.....oooooo.....',
  '......o..o......',
  '................',
  '................',
  '................',
];
